export type CatalogDescriptionSection = {
    heading?: string;
    paragraphs?: string[];
    list?: string[];
};

export type CatalogDescriptionContent = {
    url: string;
    title: string;
    intro: string;
    sections: CatalogDescriptionSection[];
};

export const CATALOG_DESCRIPTIONS: Record<string, CatalogDescriptionContent> = {
    pillows: {
        url: 'pillows',
        title: 'Шёлковые подушки S-Gabai — натуральное волокно, премиум-качество',
        intro: 'Шелковая подушка для сна — это не только элемент интерьера, но и основа здорового отдыха. Натуральное шелковое волокно мягко поддерживает голову и шею, дышит, регулирует температуру и не вызывает аллергии. Поэтому всё больше людей выбирают натуральные шелковые подушки премиум качества, которые объединяют комфорт, долговечность и роскошь.',
        sections: [
            {
                heading: 'Преимущества подушек с шелковым наполнителем',
                list: [
                    '100% натуральность — каждая подушка создана из волокна шелкопряда без синтетических добавок.',
                    'Здоровый сон — наполнитель из шелка помогает расслабиться и просыпаться без усталости.',
                    'Гипоаллергенность — изделия идеально подходят людям с чувствительной кожей и аллергикам.',
                    'Долговечность — подушки из натурального шелка не сбиваются и сохраняют форму многие годы.',
                    'Статус и качество — у нас вы можете купить подушку премиум, которая подчеркнёт вкус и заботу о здоровье.',
                ],
            },
            {
                heading: 'Коллекция подушек из шелка',
                paragraphs: [
                    'В интернет-магазине S-Gabai вы можете купить подушки из шелка в Москве с доставкой по всей России.',
                    'Каждая модель — это подушка с наполнителем из натурального шелка, созданная по традиционным технологиям.',
                ],
            },
            {
                heading: 'Сколько стоит шелковая подушка?',
                paragraphs: [
                    'Мы предлагаем продукцию только высокого уровня. Стоимость отражает натуральность и премиум-качество.',
                    'Купить подушку с шелковым наполнителем — значит инвестировать в комфорт и здоровье на долгие годы.',
                ],
            },
            {
                heading: 'Почему выбирают S-Gabai',
                list: [
                    'Прямые поставки — подушки производства Китай без посредников.',
                    'Контроль качества на производстве.',
                    'Только натуральные материалы — наполнитель из шелкового волокна сохраняет свойства долгие годы.',
                    'Ассортимент премиум-класса.',
                    'Удобная доставка по Москве и всей России.',
                ],
            },
            {
                paragraphs: [
                    'Сделайте выбор в пользу настоящего качества. Закажите шелковые подушки в интернет-магазине S-Gabai и почувствуйте разницу уже в первую ночь сна.',
                ],
            },
        ],
    },

    blankets: {
        url: 'blankets',
        title: 'Шёлковые одеяла S-Gabai — комфорт и премиум-качество',
        intro: 'Шелковое одеяло — это основа здорового и комфортного сна. Наполнитель из шелкового волокна лёгкий, «дышащий» и гипоаллергенный. Он поддерживает оптимальную температуру тела: согревает зимой и дарит прохладу летом. Поэтому всё больше людей выбирают натуральные шелковые одеяла премиум-качества как достойную альтернативу синтетическим изделиям.',
        sections: [
            {
                heading: 'Преимущества шелкового наполнителя',
                list: [
                    'Натуральность — каждое одеяло с наполнителем из шелка создаётся из волокна шелкопряда.',
                    'Комфорт — мягкость и лёгкость делают сон более глубоким и спокойным.',
                    'Гипоаллергенность — одеяло с натуральным шелковым наполнителем подходит для людей с чувствительной кожей и аллергиков.',
                    'Долговечность — наполнитель не сбивается и сохраняет свойства долгие годы.',
                ],
            },
            {
                heading: 'Коллекция S-Gabai',
                paragraphs: [
                    'В интернет-магазине S-Gabai вы можете купить одеяло из шелка в Москве с доставкой по всей России.',
                    'Все модели — это китайские шелковые одеяла, произведённые в Сучжоу, регионе, известном своими традициями шелкоткачества.',
                ],
            },
            {
                heading: 'Сколько стоит одеяло из шелка?',
                paragraphs: [
                    'Наш ассортимент включает только изделия премиум-сегмента. Купить одеяло из 100% шелка — значит инвестировать в комфорт и качество сна.',
                    'Актуальная цена на шелковые одеяла указана в карточках товаров. Выбирая продукцию S-Gabai, вы получаете натуральный наполнитель и долговечное изделие, которое будет служить годами.',
                ],
            },
            {
                heading: 'Почему выбирают S-Gabai',
                list: [
                    'Используем только натуральный шелковый наполнитель.',
                    'Контроль качества производства.',
                    'Все изделия — шелковые одеяла из Китая, поставляемые напрямую без посредников.',
                    'Ассортимент для требовательных клиентов: одеяло премиум-качества для повседневного комфорта.',
                    'Доставка по Москве и всей России.',
                ],
            },
            {
                paragraphs: ['Закажите шелковое одеяло в интернет-магазине S-Gabai и подарите себе роскошь настоящего сна.'],
            },
        ],
    },

    accessories: {
        url: 'accessories',
        title: 'Премиальный набор для сна и красоты',
        intro: 'Набор включает два аксессуара, созданных из 100% натурального шелка Mulberry: маску для сна и резинку для волос. Оба изделия разработаны для тех, кто ценит комфорт, заботу о здоровье и эстетичный стиль.',
        sections: [
            {
                heading: 'Маска для сна из натурального шелка',
                paragraphs: [
                    'Маска для сна из шелка мягко прилегает к коже, блокирует свет и помогает быстро погрузиться в глубокий сон.',
                    'Выбирая нашу продукцию, вы получаете лучшие шелковые маски для сна, которые ценят за качество и долговечность.',
                ],
                list: ['Натуральный материал бережно относится к коже век.', 'Ткань поддерживает оптимальную температуру и не вызывает раздражений.'],
            },
            {
                heading: 'Резинка для волос из шелка',
                paragraphs: [
                    'В комплект входит и резинка для волос из натурального шелка. Она не травмирует волосы, не оставляет заломов и при этом надёжно фиксирует причёску.',
                    'У нас вы можете купить шелковую резинку для волос в составе набора или отдельно. Это действительно лучшие аксессуары для тех, кто заботится о красоте и здоровье волос.',
                ],
                list: [
                    'Подходит для повседневного ношения и ночного сна.',
                    'Сохраняет структуру волос, предотвращает их ломкость.',
                    'Стильный аксессуар, который гармонично дополнит любой образ.',
                ],
            },
            {
                heading: 'Идея для подарка',
                paragraphs: [
                    'Набор упакован в стильную подарочную коробку. Это готовое решение для тех, кто ищет полезный и изысканный подарок близким или себе. Маска для сна и резинка для волос из шелка станут символом роскоши и внимания к деталям.',
                    'Закажите набор в интернет-магазине S-Gabai — и получите удовольствие от прикосновения настоящего премиального шелка каждый день.',
                ],
            },
        ],
    },
};
